import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about">
      <div className="container">
        <h2 className="section-title">Welcome To SkylinesteelDesign</h2>
        <div className="about-content">
          <div className="about-text">
           
            <p className="about-description">
              We have been increasing current standards in the matter of transmission impeccable building structures. 
              Our simple on-pocket and very solid administrations have figured out how to win numerous hearts as we 
              limit hazard and increase the value of the project.
            </p>
            <p className="about-description">
              We take advantage of our handpicked HR and current procedures to convey extends before cutoff times. 
              Our straightforward method for working has helped us win a lot more clients, who currently trust us 
              with their future projects too.
            </p>
            <p className="about-description">
              We are an organization that wears numerous caps. From being market pioneers of structural engineering, 
              design, and research, to do well architectural results in both residential and industrial divisions, 
              we are enlisting our company in different arenas. Our other important work integrates steel detailing, 
              connection design for structural, miscellaneous, pre-engineered metal buildings, BIM (Building Information 
              Modeling) services and rebar detailing services. We help the structure, expansion, alteration, and revamp 
              of new and existing constructions. And all these are finished after the OSHA guidelines with respect to us, 
              quality is as significant as wellbeing and procedures consistence.
            </p>
            <div className="about-features">
              <div className="feature">
                <div className="feature-icon">🏗️</div>
                <div>
                  <h3>Structural & Miscellaneous Steel</h3>
                  <p>We provide detailing and estimation services for structural steel, adhering to international standards such as AISC, NISD, CISC, OSHA, and ASTM</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">🏭</div>
                <div>
                  <h3>Pre-Engineered Metal Buildings</h3>
                  <p>Our expertise includes designing and detailing pre-engineered metal buildings, handling both simple and complex projects</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">👥</div>
                <div>
                  <h3>Expert Team</h3>
                  <p>Our team consists of over 13 experienced detailers proficient in AISC, BS, MBMA, ASD, AISI, AWS, MBCI, LRFD, CRSI, and ACI codes</p>
                </div>
              </div>
            </div>
          </div>
          <div className="about-feature-cards">
            <div className="feature-card">
              <div className="feature-card-header">
                <div className="feature-card-icon">👥</div>
                <h3 className="feature-card-title">PROFESSIONAL TEAM</h3>
              </div>
              <div className="feature-card-content">
                <p>Our Structural, PEMB/PEB, REBAR and detailing teams make for an endearing combination. We have team of 13+ experienced detailer who are knowledgeable in AISC, BS, MBMA, ASD, AISI, AWS, MBCI, LRFD, CRSI and ACI codes.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-card-header">
                <div className="feature-card-icon">🎧</div>
                <h3 className="feature-card-title">GREAT SUPPORT</h3>
              </div>
              <div className="feature-card-content">
                <p>Our support and advice team always helps customers to wholeheartedly and answer all customers' questions.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-card-header">
                <div className="feature-card-icon">🏠</div>
                <h3 className="feature-card-title">SMART WORK</h3>
              </div>
              <div className="feature-card-content">
                <p>We never negotiate on our quality of design and detailing regardless of how huge or small the size of the Project. We use leading-edge 3D- Tool software for Structural and Miscellaneous detailing, Just as AutoCAD, BIM coordination, Blue Beam, MS Office for portrayals and documentation.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
